import $ from "jquery";
import uly from "ulysses/base";
import ko from "knockout";
import URI from "URI/URI";
import URITemplate from "URI/URITemplate";

"use strict";

var DEFAULT_AJAX_PROPS = {
    error: function (xhr, status, error) {
        if (xhr.status == 499) {
            uly.subscribe("page.refreshsettings.start", function(topic, state) {
                window.location.reload();
            });
            uly.actions.navigateto(xhr.getResponseHeader("Location"));
        } else if (xhr.status == 406 && /login/.test(xhr.getResponseHeader("Location")) ) {
            uly.utils.show_results({
                success:false, 
                error:_("api_error_inexistent_account_or_wrong_password", "Inexistent account or wrong password")
            });
        }
    }
};

$.ajaxSetup(DEFAULT_AJAX_PROPS);
function cleanReplace(key, val) {
    if (key === "__perms__" || key === "__ko_mapping__")
        return undefined;
    return val;
}

function cleanJson(data) {
    if (!data)
        return data;
    if (Array.isArray(data)) {
        return data.map(function(v) { return cleanJson(v); });
    } else if (Object.isObject(data)) {
        Object.keys(data).forEach(function(k) {
            if (k && ["__perms__", "__ko_mapping__"].indexOf(k) >= 0) {
                delete data[k];
            } else {
                data[k] = cleanJson(data[k]);
            }
        });
        return data;
    } else return data;
}

/*$(document).ready(function() {
    $(document).ajaxStart(function() { Pace.restart(); });
});*/
function _get_full_url(url, root) {
    console.log("Get Full URL:", url, root);
    url = url || "";
    if (url.indexOf("://") >= 3 && url.indexOf("://")<10) {
        return url;
    }
    if (url.length > 0 && url.indexOf("/") !== 0) {
        url = "/" + url;
    }
    return root + url;
}

function _clean_segment(url) {
    var segments = new URI(url).segment();
    var root_segments = new URI(uly.root).segment();
    for (var i=0;i<root_segments.length;i++){
        if(segments.indexOf(root_segments[i]) != -1)
            segments.splice(segments.indexOf(root_segments[i]), 1);
    }
    return segments;
}


class API {
    constructor(root, version) {
        Object.assign(this, {
            version: version,
            root: root+version,
            action_cache: {},
            asset_cache: {},
            username: null
        })
    }

    update_credentials(username) {
        this.username = username;
    }

    start(global_params) {
        if (!global_params) {
            global_params = this.global_params || { 
                api_version:this.version, 
                username: this.username
            };
        }

        if (this.hal_root) {
            return this.hal_root;
        } else {
            this.hal_root = HalClient(this.root, true, global_params);
            this.global_params = global_params;
            return this.hal_root;
        }
    }

    post(url, route, params) {
        console.debug("POST request [url, route, params]:", url, route, params);
        if (route && route in this.routes) {
            var p = {
                api_version:this.version,
                username: ko.unwrap(this.username),
                resources: _clean_segment(url)
            };
            url = this.routes[route].expand(p);
            return $.post(url, ko.toJSON(ko.toJS(params), cleanReplace, 2));
        }
        else
            return $.post(_get_full_url(url, this.root), ko.toJSON(ko.toJS(params), cleanReplace, 2));
    }

    update(url, route, params) {
        if (route && route in this.routes){
            var p = {
                api_version: this.version,
                username: ko.unwrap(this.username),
                resources: _clean_segment(url)
            };
            url = this.routes[route].expand(p);
            return $.ajax({ "method":"patch", "url":url, "data": cleanJson(ko.toJS(params))});
        }
        else
            return $.ajax({ "method":"patch", "url":_get_full_url(url), "data": cleanJson(ko.toJS(params))});
    }

    clear_cache() {
        this.action_cache = {};
        this.asset_cache = {};
    }

    reset(new_root, new_version) {
        this.clear_cache();
        this.global_params = null;
        this.root = new_root + (new_version || this.version);
        this.version = new_version || this.version;
    }

    ping() {
        return this.start()
                   .follow("uly:admin")
                   .follow("uly:changes");
    }

    setToken(token) {
        var props = $.extend({}, DEFAULT_AJAX_PROPS);
        props.headers = {
            "Authorization": "Bearer " + token
        };
        $.ajaxSetup(props);
        this.token = token;
    }

    getAuthenticatedUrl(href) {
        if (href && href.indexOf(this.root) == 0 && this.token && (href.indexOf("$token") < 0)) {
            href += href.indexOf("?") >= 0 ? "&$token=" + this.token : "?$token=" + this.token;
        }
        return href;
    }
}


uly.api = new API("/api/","v2");
uly.URITemplate = URITemplate;

function _get_target(resource, link, prefer_embed, parameters, cache, ignore_errors) {
    var links = resource._links;
    var _lk = null;
    var _embed = null;
    var is_array = false;
    if (links && links[link]) {
        if (Array.isArray(links[link])) {
            //following an array.
            if (links[link].length > 0) {
                _lk = links[link];
                is_array = true;
            }
            else _lk = null;
        }
        else
            _lk = links[link];
    }
    else {
        /*******************
         * Allows following array indexed item: res.follow("item[1]")...
         ******/
        if (/\[\d+\]$/.test(link)) {

            var rel = link.slice(0, link.lastIndexOf("["));
            var idx = link.slice(link.lastIndexOf("[")+1, link.lastIndexOf("]"));
            var lks = links[rel];
            if (Array.isArray(lks))
                _lk = lks[idx];
        }
    }

    if (!_lk || prefer_embed) {
        if (resource._embedded) {
            _embed = resource._embedded[link];
        }
        if (_embed) {
            return Promise.Deferred().resolve(_embed);
        }
    }

    if (_lk) {
        if (!is_array) {
            var href = _lk.templated ? new URITemplate(_lk.href).expand(parameters ||{}) : _lk.href;
            var def = Promise.Deferred();
            if (cache && cache[href]) {
                return cache[href];
            } else {
                if (cache) cache[href] = def;
                def.xhr = $.get(href).done(function(result) {
                    def.resolve(result);
                }).fail(def.reject);
                return def;
            }
            var p = def.promise();
            p.xhr = def.xhr;
            return p;

        }
        else
        {
            var promises = [];
            var hrefs = [];
            _lk.forEach((lk, idx) => {
                var href = lk.templated ? new URITemplate(lk.href).expand(parameters ||{}) : lk.href;
                if (href) {
                    var def = Promise.Deferred();
                    if (cache && cache[href]) {
                        def = cache[href];
                    } else {
                        def.xhr = $.get(href).done(function(result) {
                            def.resolve(result);
                        }).fail(def.reject);
                        if (cache) cache[href] = def;
                    }
                    var promise = def.promise();
                    promise.xhr = def.xhr;
                    promises.push(promise);
                    hrefs.push(href);
                }
            });
            var big_def = Promise.Deferred();
            if (!ignore_errors) {
                Promise.when(...promises).done(function(results) {
                    big_def.resolve(results);
                }).fail(big_def.reject);
            } else {
                Promise.allSettled(promises).then((results)=> {
                    let values = results.filter((res) => res.status == "fulfilled").map((r) => r.value);
                    big_def.resolve(values);
                }, (error) => { big_def.reject(error); });
            }
            var promise = big_def.promise();
            promise.xhr = promises.map((v,idx)=>  { return v ? v.xhr : false; });
            return promise;
        }
    }
    console.log("follow: No link found for ", link, " in ", resource);

    return Promise.Deferred().reject(null);
}

var _get_target_uri = function(resource, link, parameters) {
    var links = resource._links;
    var _lk = null;
    var _embed = null;
    if (links && links[link]) {
        if (Array.isArray(links[link])) {
            _lk = links[link][0];
        }
        else
            _lk = links[link];
    }
    else {
        if (/\[\d+\]$/.test(link)) {

            var rel = link.slice(0, link.lastIndexOf("["));
            var idx = link.slice(link.lastIndexOf("[")+1, link.lastIndexOf("]"));
            var lks = links[rel];
            if (Array.isArray(lks))
                _lk = lks[idx];
        }
    }
    if (!_lk) {
        if (resource._embedded) {
            _embed = resource._embedded[link];
        }
        if (_embed && _embed.self) {
            return _embed.self.href;
        }
    }
    if (_lk) {
        if (_lk.templated) {
            return new URITemplate(_lk.href).expand(parameters ||{});
        } else return _lk.href;
    }

    return null;
};

var _get_self = function get_self(resource) {
    try {
        var lk = resource._links.self.href;
        return $.get(lk);
    }
    catch(e)
    {
        return Promise.Deferred().reject(e);
    }
};

class Resource  {

    constructor(uri_or_parent, prefer_embed, parent_parameters) {
        this._deferred = new Promise((resolve,reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        this.status = "pending";
        this._deferred.then((document) => {
            this.status = "resolved";
            this.resource = document;
        }, (error) => {
            this.status = "rejected";
            this.error = error;
        });

        this._prefer_embed = prefer_embed;
        this.parent_paremeters = parent_parameters;

        if (uri_or_parent) {
            if (typeof uri_or_parent === "string") {
                $.get(uri_or_parent).then(this.resolve, this.reject);
            }
            else if (uri_or_parent && typeof uri_or_parent.done == "function") {
                //we seem to be creating a new resource from an existing one.
                this.parent_parameters = parent_parameters || uri_or_parent.parent_parameters;
                uri_or_parent.then(this.resolve, this.reject);
            }
            else if (Object.isObject(uri_or_parent) || typeof uri_or_parent == "object") {
                this.resolve(uri_or_parent);
            }
        }
    }

    state() {
        return this.status;
    }

    then(res,rej) {
        return this._deferred.then(res,rej);
    }

    done(res) {
        return this._deferred.then(res);
    }

    fail(rej) {
        return this._deferred.then(null, rej);
    }

    always(callback) {
        return this._deferred.always(callback);
    }

    follow(link, parameters, success_callback) {
        var h = new Resource(null, this._prefer_embed, this.parent_parameters);
        if (typeof parameters  == "function" && !success_callback) {
            success_callback = parameters;
            parameters = null;
        }
        this.then(
            (document) => {
                var effective_parameters = parameters;
                if (this.parent_parameters) {
                    effective_parameters = Object.assign(Object.assign({}, this.parent_parameters), parameters);
                }

                effective_parameters = Object.assign(Object.assign({}, uly.api.global_params), effective_parameters);

                var target = _get_target(this.resource, link, this._prefer_embed, effective_parameters).then(
                    (results) => {
                        if (success_callback) {
                            success_callback.call(h, results);
                        }
                        h.resolve(results);
                    }, 
                    h.reject
                );
                h.xhr = target.xhr;
            }, 
            h.reject
        );
        return h;
    }

    download(link, parameters, success_callback) {
        var h = new Resource(null, this._prefer_embed, this.parent_parameters);
        if (typeof parameters  == "function" && !success_callback) {
            success_callback = parameters;
            parameters = null;
        }
        this.then(
            (document) => {
                var effective_parameters = parameters;
                if (this.parent_parameters) {
                    effective_parameters = Object.assign(Object.assign({}, this.parent_parameters), parameters);
                }
                effective_parameters = Object.assign(Object.assign({}, uly.api.global_params), effective_parameters);

                var target_uri = link ? _get_target_uri(this.resource, link, effective_parameters) : this.resource._links.self.href;
                //open in another window:
                window.open(target_uri);
                if (success_callback) {
                    success_callback.call(h, document);
                }
                h.resolve(document);
            }, 
            h.reject
        );
        return h;
    }
    
    follow_with_cache(link, cache, parameters, success_callback, ignore_errors) {

        var h = new Resource(null, this._prefer_embed, this.parent_parameters);
        if (typeof parameters  == "function" && !success_callback) {
            success_callback = parameters;
            parameters = null;
        } else if (typeof parameters == "boolean") {
            ignore_errors = parameters;
            parameters = null;
        }
        if (typeof ignore_errors == "undefined") {
            ignore_errors = true;
        }

        this.then(
            (document) => {
                var effective_parameters = parameters;
                if (this.parent_parameters) {
                    effective_parameters = $.extend({}, this.parent_parameters, parameters);
                }
                effective_parameters = $.extend({}, uly.api.global_params, effective_parameters);

                var target = _get_target(this.resource, link, this._prefer_embed, effective_parameters, cache, ignore_errors).then(
                    function(results) {
                        if (success_callback) {
                            success_callback.call(h, results);
                        }
                        h.resolve(results);
                    }, h.reject
                );
                h.xhr = target.xhr;
            }, 
            h.reject
        );
        return h;
    }

    post(link, parameters, data) {
        if (typeof data == "undefined") {
            data = parameters;
            parameters = null;
        }
        var h = new Resource(null, this._prefer_embed, this.parent_parameters);
        this.then(
            (document) => {
                var effective_parameters = this.parent_parameters || {};
                parameters = parameters || {};
                effective_parameters = $.extend({}, uly.api.global_params, effective_parameters, parameters);

                var target_uri = link ? _get_target_uri(this.resource, link, effective_parameters) : this.resource._links.self.href;
                if (target_uri) {
                    $.ajax({
                        "type": "POST",
                        "url": target_uri,
                        "data": ko.toJSON(ko.toJS(data), cleanReplace, 2),
                        "dataType": "json",
                        "contentType": "application/json"
                    }).then(
                        (post_result) => {
                            if (!post_result || (post_result.success !== false))
                                h.resolve(post_result);
                            else
                                h.reject(post_result);
                        },
                        (result) => { 
                            console.log("error posting:", arguments); 
                            h.reject(result); 
                        }
                    );
                }
                else {
                    console.error("Invalid post uri:", this.resource, link, effective_parameters);
                    h.reject({ "success":false, "error":_("api_error_invalid_post_uri", "Invalid post URI") });
                }
            }, 
            (error) => { 
                console.error("Error self posting:", arguments); 
                h.reject(error); 
            }
        );
        return h;
    }

    put(link, data) {
        var h = new Resource(null, this._prefer_embed, this.parent_parameters);
        this.then((document) => {
            var effective_parameters = this.parent_parameters || {};
            effective_parameters = $.extend({}, uly.api.global_params, effective_parameters);

            var target_uri = link ? _get_target_uri(this.resource, link, effective_parameters) : this.resource._links.self.href;

            if (target_uri) {
                $.ajax({
                    "url":target_uri,
                    "data":ko.toJSON(data, cleanReplace, 2),
                    "method":"PUT",
                    "dataType": "json",
                    "contentType": "application/json"
                }).then(h.resolve, h.reject);
            }
            else {
                h.reject({ "success":false, "error":_("api_error_invalid_uri", "Invalid URI") });
            }
        }, h.reject);
        return h;
    }

    delete(link, parameters, data) {
        if (typeof data == "undefined") {
            data = parameters;
            parameters = null;
        }
        var h = new Resource(null, this._prefer_embed, this.parent_parameters);
        this.then(
            (document) => {
                var effective_parameters = this.parent_parameters || {};
                effective_parameters = $.extend({}, uly.api.global_params, effective_parameters, parameters || {});
                var target_uri = link ?
                    _get_target_uri(this.resource, link, effective_parameters)
                    : this.resource._links.self.href;

                if (target_uri) {
                    $.ajax({
                        "url":target_uri,
                        "data":data !== null ? ko.toJSON(data, cleanReplace, 2) : undefined,
                        "method":"DELETE"
                    }).then(h.resolve, h.reject);
                }
                else {
                    h.reject({ "success":false, "error":_("api_error_invalid_uri", "Invalid URI") });
                }
            }, h.reject
        );
        return h;
    }

    get_uri(link, data) {
        var h = Promise.Deferred();
        this.then((document) => {
            var effective_parameters = this.parent_parameters || {};
            effective_parameters = $.extend({}, uly.api.global_params, effective_parameters);
            data = data || {};
            effective_parameters = $.extend(effective_parameters, data);

            if (link)
                var target_uri = _get_target_uri(this.resource, link, effective_parameters);
            else target_uri = this.resource._links.self.href;
            h.resolve(target_uri);
        }, h.reject);
        return h;
    }

    refresh() {
        if (this.state() == "pending")
            return this;
        var r = Promise.Deferred();
        var target = _get_self(this.resource).this((result) => {
            this.resource = result;
            r.resolve(result);
        }, r.reject);
        return r;
    }

    has_rel_s(relation, only_link) {
        if (this.state() == "pending")
            return null;
        if (this.resource._links && this.resource._links[relation])
            return this.resource._links[relation];
        if (!only_link && this.resource._embedded && this.resource._embedded[relation])
            return this.resource._embedded[relation];
    }

    has_rel(relation, only_link) {
        var res = Promise.Deferred();
        this.then(() => {
            res.resolve(this.has_rel_s(relation, only_link) );
        }, res.reject);
        return res;
    }

}

function HalResource(uri_or_parent, prefer_embed, parent_parameters) {
    return new Resource(uri_or_parent, prefer_embed, parent_parameters);
}

function HalClient(root, prefer_embed, global_params) {
    //why not simply new HalResource?
    var self = new Resource(root, prefer_embed, global_params);
    self.root = root;
    return self;
}

window.HalResource = HalResource;
uly.HalResource = HalResource;
uly.Resource = Resource;

export default HalResource;
//    var api = new HalClient(root);
//    var res = api.follow("uly:data").follow("uly:action").done(function(result) {
